module.exports = __webpack_public_path__ + "static/media/inventoryAptBook.4610a76a.svg";